define('modules/stats/collections/statistics',['require','exports','module','base/collection','../models/statistic','env','common/models/date_model'],function (require, exports, module) {
  'use strict';

  var BaseCollection = require('base/collection'),
    Statistics = require('../models/statistic'),
    config = require('env'),
    DateModel = require('common/models/date_model');

  module.exports = BaseCollection.extend({
    initialize: function (options) {
      var date = options.date || new DateModel();
      this.loaded = false;
      this.querystring = date.toJSON();
      this.fetch();
    },
    model: Statistics,
    url: config.apiHost + '/statistics',
    fetch: function (options) {
      options = _.extend({ data: this.querystring }, options);
      return module.exports.__super__.fetch.call(this, options);
    },
  });
});

